module.exports = __webpack_public_path__ + "img/ticket.6ea41374.svg";